import { useEffect } from "react";

import DepollutionTable from "../../components/depollution/DepollutionTable";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import { CheckFeatureFlag } from "../../hooks/useFeatureFlag";

export default function DepollutionList() {
  const { setInfo } = usePageNameContext();
  const isTMEEnabled = CheckFeatureFlag("TME");
  const depollutionLabel = isTMEEnabled ? "Triage" : "Depollution";

  useEffect(() => {
    setInfo({
      name: depollutionLabel,
      desc: `Vehicles with ${depollutionLabel} still in progress`,
    });
  }, []);

  return <DepollutionTable />;
}
